var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBinWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.43,
    height: 77.24,
    viewBox: "0 0 49.43 77.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-bin",
    d: "M8.3,26.066V74.34c0,2.655,1.711,4.827,3.8,4.827H46.324c2.091,0,3.8-2.172,3.8-4.827V26.066H8.3ZM19.708,69.513h-3.8V35.721h3.8Zm7.6,0h-3.8V35.721h3.8Zm7.6,0h-3.8V35.721h3.8Zm7.6,0h-3.8V35.721h3.8Zm8.555-57.93H38.72V5.549c0-1.991-1.283-3.621-2.852-3.621H22.56c-1.568,0-2.852,1.629-2.852,3.621v6.034H7.35C5.782,11.583,4.5,13.212,4.5,15.2v6.034h49.43V15.2c0-1.991-1.283-3.621-2.852-3.621Zm-16.16,0H23.51V6.816H34.917v4.767Z",
    transform: "translate(-4.499 -1.928)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBinWhite);
export default __webpack_public_path__ + "static/media/icon-bin-white.a668c23d8519fa143755f5d60bc6cdbe.svg";
export { ForwardRef as ReactComponent };